// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1R5kv","visible-sm":"visible-sm___3zG6t","visible-md":"visible-md___35QhF","visible-lg":"visible-lg___cKzKx","row":"row___26h2R","hidden-xs":"hidden-xs___2cEa6","hidden-sm":"hidden-sm___21zgR","hidden-md":"hidden-md___Go-g2","hidden-lg":"hidden-lg___gyKlS","logo-second-wrap":"logo-second-wrap___299Sg center___2iqBf","logo-equileap":"logo-equileap___1sf6G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterPartner/FooterPartner.css
// module id = 859
// module chunks = 0